module.exports = __webpack_public_path__ + "static/media/chainswap-logo.6676e141.svg";